import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from 'app/features/shared/blocks'

export const FeaturedContentCarouselBlockFragment: BlockFragment = {
  name: 'featuredContentCarousel',
  fragment: gql`
    fragment featuredContentCarousel on FeaturedContentCarousel {
      id
      blockType
      items {
        id
        title
        description
        image {
          url
          alt
        }
        link
        linkText
        newTab
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on FeaturedContentCarousel {
      id
      blockType
      items {
        id
        title
        description
        image {
          url
          alt
        }
        link
        linkText
        newTab
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const FeaturedContentCarouselBlockType = 'featuredContentCarousel'

export interface FeaturedContentCarouselBlock extends BaseBlock {
  blockType: typeof FeaturedContentCarouselBlockType
  items: {
    id: string
    title: string
    description: string
    image: {
      url: string
      alt: string
    }
    link: string
    linkText: string
    newTab: boolean
  }[]
}
